'use strict';

var unicodePunctuationRegex = require('../constant/unicode-punctuation-regex.js');

var regexCheck = require('../util/regex-check.js'); // In fact adds to the bundle size.


var unicodePunctuation = regexCheck(unicodePunctuationRegex);
module.exports = unicodePunctuation;